@if (column(); as column) {
  @if (model(); as model) {
    @switch (column.key) {
      @case (getColumnKey('file')) {
        @if (isNotNil(model.file)) {
          <app-image-thumbnail>
            <img
              [ngSrc]="model.file.url"
              [fill]="true"
              [alt]="model.file.alt"
              class="object-contain" />
          </app-image-thumbnail>
        } @else {
          <app-image-thumbnail-unsupported />
        }
      }

      @case (getColumnKey('url')) {
        @if (isNotNil(model.url)) {
          <app-external-link [link]="model.url">
            {{ model.url }}
          </app-external-link>
        } @else {
          <app-no-data />
        }
      }

      @case (getColumnKey('location')) {
        {{ model.location | bannerLocationType | async }}
      }

      @case (getColumnKey('status')) {
        @if (isNotNil(model.status)) {
          {{ model.status | adminBannerStatus | async }}
        } @else {
          <app-no-data />
        }
      }

      @default {
        <app-table-body-no-reference-cell [columnKey]="column.key" />
      }
    }
  }
}
